import { render } from "./ReferenciaDePago.vue?vue&type=template&id=5a95d3d4&scoped=true"
import script from "./ReferenciaDePago.vue?vue&type=script&lang=js"
export * from "./ReferenciaDePago.vue?vue&type=script&lang=js"

import "./ReferenciaDePago.vue?vue&type=style&index=0&id=5a95d3d4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a95d3d4"]])

export default __exports__